module.exports = __webpack_public_path__ + "img/icon_gdia.e18356df.svg";